import { render, staticRenderFns } from "./AdminVerify.vue?vue&type=template&id=27ee09c5&scoped=true"
import script from "./AdminVerify.vue?vue&type=script&lang=js"
export * from "./AdminVerify.vue?vue&type=script&lang=js"
import style0 from "./AdminVerify.vue?vue&type=style&index=0&id=27ee09c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee09c5",
  null
  
)

export default component.exports